module.exports = "<p>\n  add-folder works!\n</p>\n"


//////////////////
// WEBPACK FOOTER
// C:/projects/wct-nextias-ui/src/app/home/add-folder/add-folder.component.html
// module id = ../../../../../src/app/home/add-folder/add-folder.component.html
// module chunks = common